import { useId } from 'react';
import { InputProps } from '@/types/form/input-props';
import { Switch } from '@/shared/components/ui/switch';
import { Label } from '@/shared/components/ui/label';

export default function CardSwitchInput({
  value,
  onChange,
  label,
  name,
  description,
  disabled,
}: InputProps<boolean> & { description: string }) {
  const id = useId();

  return (
    <div className="border-input has-data-[state=checked]:border-ring relative flex w-full items-start gap-2 rounded-md border p-4 shadow-xs outline-none">
      <Switch
        id={id}
        onCheckedChange={onChange}
        checked={value}
        name={name}
        disabled={disabled}
        className="order-1 h-4 w-6 after:absolute after:inset-0 [&_span]:size-3 data-[state=checked]:[&_span]:translate-x-2 data-[state=checked]:[&_span]:rtl:-translate-x-2"
        aria-describedby={`${id}-description`}
      />
      <div className="grid grow gap-2">
        <Label htmlFor={id}>{label}</Label>
        <p id={`${id}-description`} className="text-muted-foreground text-xs">
          {description}
        </p>
      </div>
    </div>
  );
}
